import './CalendarItem.css';
export var calendarButtonCSS = '_zi1kf2-2-0-1';
export var calendarHeaderButtonCSS = '_zi1kf3-2-0-1';
export var currentIndicator = '_zi1kf1-2-0-1';
export var outOfScopeDay = '_zi1kf0-2-0-1';